import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
} from "@mui/material";

const ChangePasswordModal = ({ open, handleClose, handleSubmit, user }) => {
  const [formData, setFormData] = useState({
    newPassword: "",
  });

  useEffect(() => {
    if (user) {
      setFormData({
        newPassword: "",
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(formData);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        {user && (
          <form onSubmit={onSubmit}>
            <Typography variant="h3">
              Change Password of {user.nickname}
            </Typography>
            <div>
              <TextField
                id="newPassword"
                label="New Password"
                name="newPassword"
                variant="outlined"
                type="password"
                fullWidth
                value={formData.newPassword}
                onChange={(e) => handleChange(e)}
              />
            </div>
          </form>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button type="submit" onClick={onSubmit}>
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePasswordModal;
